import { DrawerDiaLog, DrawerDiaLogTitle } from '../drawer-dialog';
import { SearchPanel } from './search-panel';

type SearchProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const SearchModel = ({ open, setOpen }: SearchProps) => {
  return (
    <DrawerDiaLog className="h-[calc(100%-52px)] md:size-[578px] px-4 md:p-6" open={open} setOpen={setOpen}>
      <DrawerDiaLogTitle />
      <SearchPanel />
    </DrawerDiaLog>
  );
};
